<template>
  <div style="overflow-x: hidden;">
    <div class="pt-home">
      <!-- Banner（轮播） + 最新资讯 -->
      <section class="pt-hero">
        <!-- 左侧：轮播图新闻 -->
        <div class="pt-carousel" @mouseenter="stopPlay" @mouseleave="startPlay">
          <div
            v-for="(slide, i) in list1.slice(0, 5)"
            :key="i"
            class="pt-carousel__slide"
            :class="{ 'is-active': i === current }"
          >
            <img :src="imageUrl(slide.image)" :alt="slide.title" @click="goDetail(slide, 'news')">
            <div class="pt-carousel__caption" @click="goDetail(slide, 'news')">{{ slide.title }}</div>
          </div>
          <!-- 上一张 / 下一张 -->
          <button class="pt-carousel__prev" @click="prevSlide">
            <svg viewBox="0 0 24 24"><path d="M15.4 7.4 14 6l-6 6 6 6 1.4-1.4-4.6-4.6 4.6-4.6Z" /></svg>
          </button>
          <button class="pt-carousel__next" @click="nextSlide">
            <svg viewBox="0 0 24 24"><path d="M10 6 8.6 7.4l4.6 4.6-4.6 4.6L10 18l6-6-6-6Z" /></svg>
          </button>
          <div class="pt-carousel__dots">
            <button
              v-for="(slide, i) in list1.slice(0, 5)"
              :key="i"
              type="button"
              class="pt-carousel__dot"
              :class="{ 'is-active': i === current }"
              :aria-label="`第${i + 1}张`"
              @click="goSlide(i)"
            />
          </div>
        </div>

        <!-- 右侧：最新资讯 -->
        <div class="pt-news">
          <div class="pt-news__head">
            <h2 class="pt-news__title">最新资讯</h2>
            <a class="pt-news__more" @click="goChannel">更多 +</a>
          </div>
          <ul v-if="list14.length > 0" class="pt-news__list">
            <li v-for="(item, i) in list14.slice(0, 5)" :key="i" class="pt-news__item">
              <a class="pt-news__link" @click="goDetail(item, 'news')">
                <span class="pt-news__dot" />
                <span class="pt-news__name">{{ item.title }}</span>
                <time class="pt-news__date">{{ formatDate(item.date) }}</time>
              </a>
            </li>
          </ul>
          <div v-else class="pt-home__empty">暂无数据</div>
        </div>
      </section>
      <!-- 服务入口 -->
      <section class="pt-services">
        <a
          v-for="s in services"
          :key="s.title"
          class="pt-svc"
          @click="handleServiceClick(s)"
        >
          <span class="pt-svc__icon" :style="{ background: s.tint }">
            <img :src="s.icon" :alt="s.title">
          </span>
          <span class="pt-svc__meta">
            <span class="pt-svc__title">{{ s.title }}</span>
            <span class="pt-svc__desc">{{ s.desc }}</span>
          </span>
        </a>
      </section>

      <!-- 协会动态 / 党建工作 / 协会通知 -->
      <section class="pt-grid-3">
        <info-card title="协会动态" channel="news">
          <template v-if="list1.length > 0">
            <a v-for="(item, i) in list1.slice(0, 2)" :key="i" class="pt-dyn" @click="goDetail(item, 'news')">
              <img class="pt-dyn__thumb" :src="imageUrl(item.image)" alt="">
              <span class="pt-dyn__body">
                <span class="pt-dyn__title">{{ item.title }}</span>
                <time class="pt-dyn__time">{{ item.datetime }}</time>
              </span>
            </a>
          </template>
          <div v-else class="pt-home__empty">暂无数据</div>
        </info-card>

        <info-card title="党建工作" channel="party">
          <template v-if="list2.length > 0">
            <div v-for="(item, i) in list2.slice(0, 3)" :key="i" class="pt-party">
              <a class="pt-party__title" @click="goDetail(item, 'party')">{{ item.title }}</a>
              <p class="pt-party__desc">{{ item.contentPure }}</p>
            </div>
          </template>
          <div v-else class="pt-home__empty">暂无数据</div>
        </info-card>

        <info-card title="协会通知" channel="news">
          <link-list @item-click="goDetail($event, 'news')" :items="list3.slice(0, 5)" :hide-date="true" :fill="true" />
        </info-card>
      </section>

      <!-- 行业动态 -->
      <info-card title="行业动态" channel="industry">
        <link-list @item-click="goDetail($event, 'industry')" :items="list4.slice(0, 10)" :columns="2" />
      </info-card>

      <!-- 会员服务 / 会展服务 -->
      <section class="pt-grid-2">
        <info-card title="会员服务" channel="member" @more-click="handleMemberMoreClick">
          <link-list @item-click="goDetail($event, 'member')" :items="list5.slice(0, 5)" :fill="true" />
        </info-card>
        <info-card title="会展服务" channel="exhibition">
          <link-list @item-click="goDetail($event, 'exhibition')" :items="list6.slice(0, 5)" :fill="true" />
        </info-card>
      </section>

      <!-- 经济运行分析 / 意见征集 / 科技创新 -->
      <section class="pt-grid-3">
        <info-card title="经济运行分析" channel="economy">
          <link-list @item-click="goDetail($event, 'economy')" :items="list7.slice(0, 5)" :fill="true" />
        </info-card>
        <info-card title="意见征集" channel="opinion">
          <link-list @item-click="goDetail($event, 'opinion')" :items="list8.slice(0, 5)" :fill="true" />
        </info-card>
        <info-card title="科技创新" channel="tech">
          <link-list @item-click="goDetail($event, 'tech')" :items="list9.slice(0, 5)" :fill="true" />
        </info-card>
      </section>

      <!-- 政策法规 -->
      <info-card title="政策法规" channel="policy">
        <link-list @item-click="goDetail($event, 'policy')" :items="list10" :columns="2" />
      </info-card>

      <!-- 媒体聚焦 / 交通数据 / 教育培训 -->
      <section class="pt-grid-3">
        <info-card title="媒体聚焦" channel="media">
          <link-list @item-click="goDetail($event, 'media')" :items="list11.slice(0, 5)" :fill="true" />
        </info-card>
        <info-card title="交通数据" channel="traffic">
          <link-list @item-click="goDetail($event, 'traffic')" :items="list12.slice(0, 5)" :fill="true" />
        </info-card>
        <info-card title="教育培训" channel="training">
          <link-list @item-click="goDetail($event, 'training')" :items="list13.slice(0, 5)" :fill="true" />
        </info-card>
      </section>
    </div>
    <!-- 会员服务未登录提示弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="showMemberDialog"
      top="25vh"
      width="420px"
      :close-on-click-modal="false"
      center
    >
      <div style="text-align: center; padding: 20px 0; font-size: 15px; color: #333;">
        <p style="margin: 0;">仅对会员可见，请先登录</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showMemberDialog = false">取 消</el-button>
        <el-button type="primary" @click="showMemberDialog = false; $router.push('/login')">去登录</el-button>
      </span>
    </el-dialog>
    <!-- 非会员提示弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="showNotMemberDialog"
      top="25vh"
      width="420px"
      :close-on-click-modal="false"
      center
    >
      <div style="text-align: center; padding: 20px 0; font-size: 15px; color: #333;">
        <p style="margin: 0;">{{ notMemberDialogMsg }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showNotMemberDialog = false">取 消</el-button>
        <el-button v-if="notMemberDialogMsg === '当前板块仅对会员开放，请先入会'" type="primary" @click="showNotMemberDialog = false; $router.push('/home')">去入会</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import InfoCard from './components/InfoCard.vue'
import LinkList from './components/LinkList.vue'
import { cmsHomePage } from '@/http/api/CmsApi'
import { IndexStore } from '@/store/module/index'
import icon1 from '@/assets/images/nav_1.png'
import icon2 from '@/assets/images/nav_2.png'
import icon3 from '@/assets/images/nav_3.png'
import icon4 from '@/assets/images/nav_4.png'

// API 返回 list1~list14 对应的模块
// list1:协会动态  list2:党建工作  list3:协会通知  list4:行业动态
// list5:会员服务  list6:会展服务  list7:经济运行  list8:意见征集
// list9:科技创新  list10:政策法规  list11:媒体聚焦  list12:交通数据
// list13:教育培训  list14:最新资讯

function mapItem (item) {
  var pt = item.publishTime || ''
  return {
    title: item.title || item.name || '',
    date: String(pt).substring(0, 10),
    datetime: pt,
    desc: item.desc || item.summary || item.remark || '',
    contentPure: item.contentPure || item.content || item.desc || '',
    id: item.id || item.articleId || '',
    image: item.image || item.picUrl || item.cover || ''
  }
}

export default {
  name: 'PortalHome',
  components: { InfoCard, LinkList },
  data () {
    return {
      slides: [],
      current: 0,
      timer: null,
      loading: false,
      // list1 协会动态
      list1: [],
      // list2 党建工作
      list2: [],
      // list3 协会通知
      list3: [],
      // list4 行业动态
      list4: [],
      // list5 会员服务
      list5: [],
      // list6 会展服务
      list6: [],
      // list7 经济运行分析
      list7: [],
      // list8 意见征集
      list8: [],
      // list9 科技创新
      list9: [],
      // list10 政策法规
      list10: [],
      // list11 媒体聚焦
      list11: [],
      // list12 交通数据
      list12: [],
      // list13 教育培训
      list13: [],
      // list14 最新资讯
      list14: [],
      showMemberDialog: false,
      showNotMemberDialog: false,
      notMemberDialogMsg: '当前板块仅对会员开放，请先入会',
      services: [
        { icon: icon1, title: '会员服务', desc: '会员权益与专属服务', tint: '#eff6ff', path: '/portal/member', needLogin: true },
        { icon: icon2, title: '我要入会', desc: '在线申请加入协会', tint: '#f0fdf4', path: '/home', needLogin: false },
        { icon: icon3, title: '直通协会', desc: '与协会各部门直接沟通', tint: '#fffbeb', path: '/serve', needLogin: true },
        { icon: icon4, title: '会员交流', desc: '会员间互动交流平台', tint: '#faf5ff', path: '/serve', needLogin: true }
      ]
    }
  },
  mounted () {
    this.loadHomeData()
  },
  beforeDestroy () {
    this.stopPlay()
  },
  methods: {
    loadHomeData: function () {
      var self = this
      self.loading = true
      cmsHomePage({ id: window.localStorage.getItem('userRole') || '' }).then(function (res) {
        self.loading = false
        if (res.code === '000' || res.code === '1') {
          var data = res.result || {}
          // list1~list14
          for (var i = 1; i <= 14; i++) {
            var arr = data['list' + i] || []
            self['list' + i] = Array.isArray(arr) ? arr.map(mapItem) : []
          }
        }
        self.$nextTick(function () { self.startPlay() })
      }).catch(function () {
        self.loading = false
        self.$nextTick(function () { self.startPlay() })
      })
    },

    startPlay () {
      this.stopPlay()
      var list = this.list1.slice(0, 5)
      if (list.length > 1) this.timer = setInterval(this.next, 4500)
    },
    stopPlay () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    next () {
      var len = this.list1.slice(0, 5).length
      this.current = (this.current + 1) % len
    },
    prevSlide () {
      var len = this.list1.slice(0, 5).length
      this.current = (this.current - 1 + len) % len
      this.startPlay()
    },
    nextSlide () {
      var len = this.list1.slice(0, 5).length
      this.current = (this.current + 1) % len
      this.startPlay()
    },
    goSlide (i) {
      this.current = i
      this.startPlay()
    },
    imageUrl: function (path) {
      if (!path) return ''
      return process.env.VUE_APP_IMG_URL + path
    },
    isLoggedIn: function () {
      return !!window.localStorage.getItem('token')
    },
    handleServiceClick: function (s) {
      if (!s.path) return
      if (this.isLoggedIn()) {
        // 会员服务 → 检查 Vuex 角色
        if (s.title === '会员服务') {
          this.checkMemberRole()
          return
        }
        this.navigateTo(s.path)
        return
      }
      if (!s.needLogin) {
        this.navigateTo(s.path)
        return
      }
      // 未登录 → 弹出提示弹窗
      if (s.title === '会员服务' || s.title === '直通协会' || s.title === '会员交流') {
        this.showMemberDialog = true
        return
      }
      this.$router.push(s.fallback || '/login')
    },
    handleMemberMoreClick: function () {
      if (!this.isLoggedIn()) {
        this.showMemberDialog = true
        return
      }
      this.checkMemberRole()
    },
    checkMemberRole: function () {
      var userInfo = IndexStore.userInfo || {}
      var roles = userInfo.userRoles ? userInfo.userRoles.split(',') : []
      if (roles.indexOf('ROLE_enterprise') !== -1 || roles.indexOf('ROLE_personal') !== -1) {
        this.notMemberDialogMsg = '当前板块仅对会员开放，请先入会'
        this.showNotMemberDialog = true
      } else {
        this.$router.push('/portal/member')
      }
    },
    navigateTo: function (path) {
      if (/^https?:\/\//.test(path)) {
        window.location.href = path
      } else {
        this.$router.push(path)
      }
    },
    goChannel: function () {
      this.$router.push('/portal/hotnews').catch(function () {})
    },
    goDetail: function (item, channel) {
      var id = item ? (item.id || item.articleId || '') : ''
      if (id) {
        this.$router.push({
          path: '/portal/detail/' + id,
          query: { channel: channel || '' }
        })
      }
    },
    formatDate: function (str) {
      if (!str) return ''
      return String(str).substring(0, 10)
    }
  }
}
</script>

<style lang="less" scoped>
.pt-home {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 30px 12px 20px;
}
/* 等价于 space-y-5：子块之间纵向间距 */
.pt-home > * + * {
  margin-top: 20px;
}

/* ===== Banner（轮播） + 最新资讯 ===== */
.pt-hero {
  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: stretch;
}
/* 全宽 130px 蓝色背景 */
.pt-hero::before {
  content: '';
  position: absolute;
  top: -30px;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  height: 130px;
  background: #0A447C;
  z-index: -1;
}

/* 左侧轮播：初始 544×306（16:9）。窄屏满宽自适应，桌面端固定 544（见下方媒体查询） */
.pt-carousel {
  position: relative;
  width: 100%;
  aspect-ratio: 544 / 306;
  overflow: hidden;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
/* 旧浏览器不支持 aspect-ratio 时，用 padding 撑起 16:9，避免高度塌陷 */
@supports not (aspect-ratio: 1 / 1) {
  .pt-carousel::before {
    content: '';
    display: block;
    padding-top: 56.25%; /* 306 / 544 */
  }
}
.pt-carousel__slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.5s ease;
}
.pt-carousel__slide.is-active {
  opacity: 1;
}
.pt-carousel__slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}
.pt-carousel__caption {
  cursor: pointer;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 24px 110px 12px 16px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.72));
  color: #fff;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pt-carousel__dots {
  position: absolute;
  right: 12px;
  bottom: 12px;
  z-index: 2;
  display: flex;
  gap: 6px;
}
.pt-carousel__dot {
  width: 8px;
  height: 8px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.55);
  cursor: pointer;
  transition: width 0.2s, background 0.2s;
}
.pt-carousel__dot.is-active {
  width: 18px;
  background: #ffc85c;
}
/* 上一张 / 下一张 */
.pt-carousel__prev,
.pt-carousel__next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.85);
  color: #333;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s, background 0.2s;
}
.pt-carousel:hover .pt-carousel__prev,
.pt-carousel:hover .pt-carousel__next {
  opacity: 1;
}
.pt-carousel__prev { left: 10px; }
.pt-carousel__next { right: 10px; }
.pt-carousel__prev svg,
.pt-carousel__next svg {
  width: 20px;
  height: 20px;
  fill: currentColor;
}
.pt-carousel__prev:hover,
.pt-carousel__next:hover {
  background: #fff;
  color: #0a447c;
}
/* 右侧最新资讯：白色卡片，填充轮播右侧剩余宽度 */
.pt-news {
  z-index: 10;
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--pt-line, #eef0f2);
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.pt-news__head {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--pt-line-2, #e5e7eb);
}
.pt-news__title {
  position: relative;
  margin: 0;
  padding-left: 12px;
  color: #1a1f2b;
  font-size: 17px;
  font-weight: 700;
}
.pt-news__title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  border-radius: 999px;
  background: #2663b8;
}
.pt-news__more {
  color: #9ea3b0;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.2s;
}
.pt-news__more:hover {
  color: #2663b8;
}
.pt-news__list {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  margin: 0;
  padding: 2px 16px 8px;
  list-style: none;
}
.pt-news__item {
  flex: 1 1 0;
  border-bottom: 1px dashed #e5e7eb;
}
.pt-news__item:last-child {
  border-bottom: 0;
}
.pt-news__link {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
  min-height: 40px;
  padding: 8px 0;
  cursor: pointer;
}
.pt-news__dot {
  flex: none;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #2663b8;
  transition: background 0.2s;
}
.pt-news__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  color: #1a1f2b;
  transition: color 0.2s;
}
.pt-news__date {
  flex: none;
  font-size: 12px;
  color: #9ea3b0;
}
/* 悬停：圆点变红、标题变蓝 */
.pt-news__link:hover .pt-news__dot {
  background: #c4203b;
}
.pt-news__link:hover .pt-news__name {
  color: #2663b8;
}
/* 空状态 */
.pt-home__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: var(--pt-muted, #9ca3af);
  font-size: 13px;
}

/* ===== 服务入口 ===== */
.pt-services {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}
.pt-svc {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  padding: 16px;
  overflow: hidden;
  background: #fff;
  border: 1px solid var(--pt-line, #eef0f2);
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  cursor: pointer;
  /* 移入移出平滑过渡 */
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}
/* 左侧品牌色装饰条：默认收起，移入时从中间纵向展开 */
.pt-svc::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #0a447c;
  transform: scaleY(0);
  transition: transform 0.25s ease;
}
/* 鼠标移入：整体上浮 + 阴影加深 + 边框提亮 + 装饰条展开 */
.pt-svc:hover {
  transform: translateY(-4px);
  border-color: #cfe0f2;
  box-shadow: 0 10px 22px rgba(10, 68, 124, 0.14);
}
.pt-svc:hover::before {
  transform: scaleY(1);
}
.pt-svc__icon {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 8px;
  transition: transform 0.25s ease;
}
.pt-svc:hover .pt-svc__icon {
  transform: scale(1.08);
}
.pt-svc__icon img {
  width: 28px;
  height: 28px;
  object-fit: contain;
}
.pt-svc__meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.pt-svc__title {
  font-size: 16px;
  font-weight: 700;
  // color: var(--pt-ink, #1f2937);
  color: #0A447C;
}
.pt-svc__desc {
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: var(--pt-muted, #9ca3af);
}

/* ===== 通用栅格 ===== */
.pt-grid-2,
.pt-grid-3 {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 20px;
  grid-auto-rows: 300px;
  overflow: hidden;
}

@media (min-width: 768px) {
  .pt-grid-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .pt-grid-3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .pt-grid-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
.pt-card--fixed {
  min-height: 300px;
}

/* 协会动态（图文条目，平分高度） */
.pt-dyn {
  display: flex;
  flex: 1 1 0;
  gap: 12px;
  padding: 20px 0;
  border-bottom: 1px dashed var(--pt-line-2, #e5e7eb);
}
.pt-dyn:last-child {
  border-bottom: 0;
}
.pt-dyn__thumb {
  flex: none;
  width: 122px;
  height: 85px;
  border-radius: 4px;
  object-fit: cover;
  background: #e5e7eb;
}
.pt-dyn__body {
  padding: 2px 0;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  height: 80px;
}
.pt-dyn__title {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 16px;
  font-weight: 500;
  color: var(--pt-brand, #1e63b0);
}
.pt-dyn:hover .pt-dyn__title {
  text-decoration: underline;
}
.pt-dyn__time {
  margin-top: 4px;
  text-align: right;
  font-size: 12px;
  color: var(--pt-muted, #9ca3af);
}

/* 党建工作（平分高度） */
.pt-party {
  flex: 0 0 33.33%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4px 0;
  border-bottom: 1px dashed var(--pt-line-2, #e5e7eb);
  overflow: hidden;
}
.pt-party:last-child {
  border-bottom: 0;
}
.pt-party__title {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  color: var(--pt-ink, #1f2937);
  cursor: pointer;
  transition: color 0.2s;
}
.pt-party__title:hover {
  color: var(--pt-brand, #1e63b0);
}
.pt-party__desc {
  display: -webkit-box;
  margin: 2px 0 0;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 12px;
  line-height: 20px;
  color: var(--pt-muted, #9ca3af);
  text-indent: 2em;
}

/* ≥640px */
@media (min-width: 640px) {
  .pt-home {
    padding: 20px 16px 20px;
  }
  .pt-services {
    grid-template-columns: repeat(2, 1fr);
  }
  .pt-hero::before {
    top: -20px;
  }
}

/* ≥1024px */
@media (min-width: 1024px) {
  /* 左侧轮播固定 544×306，右侧最新资讯填充剩余宽度 */
  .pt-hero {
    flex-direction: row;
  }
  .pt-carousel {
    flex: none;
    width: 544px;
  }
  .pt-services {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
